import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { messages } from 'vee-validate/dist/locale/pt_BR.json'
import * as rules from 'vee-validate/dist/rules'

const VeeValidatePlugin = {
  install (Vue, options) {
    Object.keys(rules).forEach(rule => {
      extend(rule, {
        ...rules[rule],
        message: messages[rule],
      })
    })

    Vue.component('ValidationProvider', ValidationProvider)
    Vue.component('ValidationObserver', ValidationObserver)
  },
}

export default VeeValidatePlugin
